import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useNewProjectUrl, useProjectDataContext } from 'domain/shared/newProject';
import DashboardBreadcrumbs from '../shared/breadcrumbs/DashboardBreadcrumbs';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const ProjectReviewBreadcrumbs = () => {
  const { data: project } = useProjectDataContext();
  const { getControlsUrl } = useNewProjectUrl();

  return (
    <DashboardBreadcrumbs>
      <ListBreadcrumbItem entity={project.name || EMPTY_VALUE_INDICATOR} link={getControlsUrl(project.id)} />
      <ListBreadcrumbItem entity="Project review" />
    </DashboardBreadcrumbs>
  );
};

export default ProjectReviewBreadcrumbs;
